'use client'

import Text from '@mui/material/Typography'

import CustomerQuote from '@/components/CustomerQuote'

const PayhawkCustomerQuote = () => (
    <CustomerQuote
        sx={{
            height: {
                xs: `792px`,
                sm: `792px`,
                md: `480px`,
                lg: `480px`,
                xl: `480px`,
            },
        }}
        light={false}
        backgroundImageSrc={'/images/payhawk-case-study/payhawk-quote-keranova-desktop.png'}
        mobileBackgroundImageSrc={'/images/payhawk-case-study/payhawk-quote-keranova-mobile.png'}
        text={
            <Text
                sx={{
                    lineHeight: '120%',
                    fontSize: {
                        xs: '24px',
                        sm: '24px',
                        md: '24px',
                        lg: '32px',
                        xl: '32px',
                    },
                }}
            >
                {`Implementing Lune's API was remarkably straightforward.`}
            </Text>
        }
        avatar={{
            title: 'Elena Keranova',
            subtitle: 'Director of Engineering at Payhawk',
            imageSrc: '/images/payhawk-case-study/elena.png',
        }}
    />
)

export default PayhawkCustomerQuote
